import React, { useState, useRef, useEffect } from 'react';
import { useDashboard } from '../contexts/DashboardContext';

export const TemplatesDropdown: React.FC = () => {
  const { loadTemplate, templates } = useDashboard();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleSelectTemplate = (templateSlug: string) => {
    loadTemplate(templateSlug);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef} data-tour="templates">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1.5 px-2.5 py-1 text-xs text-gray-300 bg-dark-bg hover:bg-dark-surface-light border border-dark-border rounded transition-colors"
      >
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        Templates
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 w-56 bg-dark-surface border border-dark-border rounded-lg shadow-lg overflow-hidden z-50">
          <div className="py-1">
            {templates.length === 0 ? (
              <div className="px-4 py-2.5 text-sm text-gray-400">Loading templates...</div>
            ) : (
              templates.map((template) => (
                <button
                  key={template.slug}
                  onClick={() => handleSelectTemplate(template.slug)}
                  className="w-full flex flex-col items-start px-4 py-2.5 hover:bg-dark-surface-light transition-colors text-left"
                >
                  <div className="text-sm font-medium text-gray-100">{template.name}</div>
                  <div className="text-xs text-gray-400 mt-0.5">{template.description}</div>
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};
